import { LightningIcon } from '@braskai/icons';
import { Typography, useDeviceType } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

export const PricingHeader = () => {
  const { isMobile } = useDeviceType();

  return (
    <Stack alignItems="center" gap={isMobile ? 8 : 12}>
      <Stack
        sx={{
          backgroundColor: 'primary.50',
          borderRadius: 360,
          color: 'grey.900',
          paddingX: 6,
          paddingY: 2,
        }}
        alignItems="center"
        direction="row"
        gap={4}
      >
        <LightningIcon height={20} width={20} />
        <Typography color="grey.900" variant="body-2-md">
          Pricing
        </Typography>
      </Stack>

      <Stack alignItems="center" gap={isMobile ? 8 : 12}>
        <Typography color="grey.900" sx={{ textAlign: 'center' }} variant={isMobile ? 'title-2-md' : 'title-1-md'}>
          Plans that scale with your video output
        </Typography>
        <Typography
          color="primary.700"
          sx={{ maxWidth: 640, textAlign: 'center' }}
          variant={isMobile ? 'body-2-md' : 'body-1-md'}
        >
          Every plan includes video translation into any language, emotion-preserving voice cloning, and free,
          easy-to-use controls.
        </Typography>
      </Stack>
    </Stack>
  );
};
